import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { FieldDatePicker } from '@/components/form'

const EndDateField = ({ data }) => {
  const { t } = useTranslation()

  const initialMonth = () => {
    return data.start_date ? moment(data.start_date) : null
  }

  return (
    <FieldDatePicker
      name="end_date"
      placeholder={t(`l.contract.edit.end_date.label`)}
      required
      disabled={!data.start_date}
      initialFocusedDate={initialMonth()}
      minDate={moment(data.start_date)}
      minDateMessage={null}
    />
  )
}

export default EndDateField
